import { defineStore } from 'pinia';
import BomHelper from '../lib/BomHelper';

function noResult() {
  return {
    smartMatch: null,
    matchingParts: [],
    otherParts: [],
  };
}

export default defineStore('partAssignment', {
  state: () => ({
    active: false,
    helper: null,
    toBeAssignedParts: [],
    wizard: {
      active: false,
      partGroups: [],
      progress: 0,
    },
    error: false,
    result: noResult(),
    searchController: null,
  }),
  getters: {
    searching() {
      return this.searchController !== null;
    },
  },
  actions: {
    initialize(endpoints) {
      this.helper = new BomHelper(endpoints);
    },
    softReset() {
      // Keep helper with endpoints across reset
      const helper = this.helper;
      this.$reset();
      this.helper = helper;
    },
    startAssignment(parts) {
      this.softReset();
      this.active = true;
      this.toBeAssignedParts = parts;
    },
    startWizard(partGroups) {
      this.softReset();
      this.active = true;
      this.wizard.active = true;
      this.wizard.partGroups = partGroups;
      this.toBeAssignedParts = partGroups[0];
    },
    progressWizard() {
      const newProgress = this.wizard.progress + 1;
      if (this.wizard.partGroups.length > newProgress) {
        this.wizard.progress = newProgress;
        this.toBeAssignedParts = this.wizard.partGroups[newProgress];
      } else {
        this.finishAssignment();
      }
    },
    finishAssignment() {
      this.active = false;
    },
    async searchParts(searchTerm, name, forceSearch, distributorSearch, footprint) {
      this.error = false;
      this.result = noResult();
      if (searchTerm === '') {
        return;
      }

      // Cancel running query and create new handle
      if (this.searchController) this.searchController.abort();
      const searchController = new AbortController();
      this.searchController = searchController;

      try {
        const result = await this.helper.search(searchTerm, name, forceSearch, distributorSearch, footprint);
        if (!searchController.signal.aborted) {
          this.result = result;
          this.searchController = null;
        }
      } catch {
        this.error = true;
      }
    },
  },
});
